import { render } from "./MindMap.vue?vue&type=template&id=5123d776&scoped=true"
import script from "./MindMap.vue?vue&type=script&lang=js"
export * from "./MindMap.vue?vue&type=script&lang=js"

import "./MindMap.vue?vue&type=style&index=0&id=5123d776&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5123d776"]])

export default __exports__